import React from "react";
import SettingsHeader from "../../components/Profile/SettingsHeader";
import { GLOBAL_IMAGES } from "../asset";
import AboutContent from "../../components/about/AboutContent";

const About = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="settings-page min-h-screen flex flex-col bg-blue-50 font-mali"
    >
      <SettingsHeader name="About Us" oneBack="true" />
      <AboutContent />
    </div>
  );
};

export default About;
